import React, { ChangeEvent, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

import { useContactsContext } from '../contexts/ContactsContext';
import { ContentContainer, FormContainer, FormSubtitle, ScrollableContent, Separator } from '../components/styled';
import { ContactFormForm, SubmitButtonGroup } from '../components/styled/ContactsForm';
import { ContactsButton } from '../components/styled/ContactsButton';
import { StyledFormControl, StyledFormControlTextareaContainer } from '../components/styled/Inputs';

declare const WEBAPP_URL: string;

function CustomerSupport() {
  const contactsContext = useContactsContext();
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const selfContact = contactsContext.selfContact;

  useEffect(() => {
    if (selfContact?.personalEmail?.displayEmail) {
      setEmail(selfContact.personalEmail.displayEmail);
    } else if (selfContact?.professionalEmail?.displayEmail) {
      setEmail(selfContact.professionalEmail.displayEmail);
    }

    if (selfContact?.primaryMobile?.displayNumber) {
      setPhone(selfContact.primaryMobile.displayNumber);
    } else if (selfContact?.personalMobile?.displayNumber) {
      setPhone(selfContact.personalMobile.displayNumber);
    } else if (selfContact?.professionalMobile?.displayNumber) {
      setPhone(selfContact.professionalMobile.displayNumber);
    }
  }, [selfContact]);

  const name = selfContact?.name?.fullName ?? '';

  return (
    <>

      <ContentContainer>
        <ScrollableContent>
          <FormContainer>
            <ContactFormForm action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8"
                             method="POST">
              <input type="hidden" name="orgid" value="00D3t000000ziwe"/>
              <input type="hidden" name="retURL" value={`https://${WEBAPP_URL}/`}/>
              <select hidden={true} id="00N3t00000G3Owy" name="00N3t00000G3Owy" title="Platform">
                <option value="Desktop">Desktop</option>
              </select>

              <FormSubtitle>Personal Information</FormSubtitle>

              <Separator/>

              <StyledFormControl id="name" maxLength={80} name="name" placeholder="Name" defaultValue={name}/>
              <StyledFormControl id="email" maxLength={80} name="email" placeholder="Email (*required)" value={email}
                                 onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                   setEmail(e.target.value);
                                 }} aria-required={true}/>
              <StyledFormControl id="phone" maxLength={40} name="phone" placeholder="Phone Number (*required)"
                                 value={phone}
                                 onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                   setPhone(e.target.value);
                                 }} aria-required={true}/>

              <FormSubtitle>Additional Information</FormSubtitle>

              <Separator/>

              <StyledFormControl id="subject" maxLength={80} name="subject" placeholder="Subject"/>
              <StyledFormControlTextareaContainer>
                <Form.Control as="textarea" name="description" placeholder="Description"></Form.Control>
              </StyledFormControlTextareaContainer>

              <SubmitButtonGroup>
                <ContactsButton hover={true} disabled={!(phone.length > 0 && email.length > 0)} type="submit"
                                name="submit">Submit</ContactsButton>
              </SubmitButtonGroup>
            </ContactFormForm>
          </FormContainer>
        </ScrollableContent>
      </ContentContainer>
    </>
  );
}

export default CustomerSupport;
